<template>
  <SHeading class="homepage-reviews__title" color="primary" level="2" size="2">
    {{ tr("client.homepage.reviews_real_people_experiences") }}
  </SHeading>
  <SReviews v-if="reviews?.length" layout="grid" :reviews="reviews" />
  <SReviewsSkeleton v-else-if="state.status === 'pending'" />
  <SErrorMessage v-else-if="state.status === 'error'" retry @retry="refetch" />
  <div class="homepage-reviews__cta">
    <SButton
      action-type="tertiary-soft"
      external
      suffix-icon="fas fa-arrow-right"
      :tag="NuxtLink"
      :to="ziggy('client.reviews.overview')"
    >
      {{ tr("client.homepage.reviews_read_all") }}
    </SButton>
  </div>
</template>

<script setup lang="ts">
import { useQuery } from "@pinia/colada";
import { NuxtLink } from "#components";

import { SButton } from "@solvari/common-fe";
import {
  SErrorMessage,
  SHeading,
  SReviews,
  SReviewsSkeleton,
} from "@solvari/components";
import { useI18nClient } from "@solvari/translations";

import { useHomepageReviews } from "~/features/homepage/api/homepage.api.ts";
import { useHostLocale } from "~/shared/composables/useHost.ts";
import { ziggy } from "~/shared/libs/ziggy.ts";

const { tr } = useI18nClient();
const locale = useHostLocale();
const {
  state,
  refetch,
  data: reviews,
} = useQuery(useHomepageReviews({ locale }));
</script>

<style lang="postcss">
.homepage-reviews {
  &__title {
    @apply mb-4;
  }

  &__cta {
    @apply mt-6 flex justify-center;
  }
}
</style>
